// extracted by mini-css-extract-plugin
module.exports = {"content":"StepContentSectionV2_content__MvaF2"};